import React from "react";
import { FaEye, FaSpinner } from "react-icons/fa";

const TestHistoryModalComponent = ({
    show,
    selectedTest,
    fields,
    saving,
    uploading,
    fileInputRefs,
    vid,
    onClose,
    onFieldChange,
    onAttachFile,
    onDeleteAttachment,
    onSave,
    onViewAttachment,
}) => {
    if (!show || !selectedTest) return null;

    const isFullyFilled = fields.length > 0 && fields.every(f => f._isPrefilled);

    return (
        <>
            <div className="modal-backdrop"></div>
            <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-l" role="document">
                    <div className="modal-content">
                        <div className="modal-header p-2 ml-1">
                            <h5 className="modal-title">
                                History - {selectedTest.Test_Name} ({selectedTest.Test_Code})
                            </h5>
                            <button
                                type="button"
                                className="btn-close btn-close-white"
                                onClick={onClose}
                            ></button>
                        </div>

                        <div className="modal-body" style={{ maxHeight: "65vh", overflowY: "auto" }}>
                            {fields.length > 0 ? (
                                isFullyFilled ? (
                                    // Read-only view — all attributes are already filled
                                    <div className="row g-2">
                                        {fields.map((field, idx) => (
                                            <div key={idx} className="col-12">
                                                <div className="card shadow-sm border rounded p-2">
                                                    <div className="d-flex flex-column">
                                                        <div className="d-flex align-items-center mb-1">
                                                            <span className="fw-bold me-1">Name:</span>
                                                            <span>{field.History_Name}</span>
                                                        </div>
                                                        {field.History_Attribute !== "Attachement" ? (
                                                            <div className="d-flex align-items-center">
                                                                <span className="fw-bold me-1">Value:</span>
                                                                <span className="text-muted">{field.History_Value || "—"}</span>
                                                            </div>
                                                        ) : (
                                                            (() => {
                                                                const typeCounters = {};
                                                                return (
                                                                    <ul className="list-group small mt-1">
                                                                        {field.HistoryAttachments?.length > 0 ? (
                                                                            field.HistoryAttachments.map((attachment, aidx) => {
                                                                                if (!typeCounters[attachment.fileType]) { typeCounters[attachment.fileType] = 1; } else { typeCounters[attachment.fileType]++; }
                                                                                const displayIndex = typeCounters[attachment.fileType];
                                                                                return (
                                                                                    <li key={aidx} className="list-group-item uploaded-docs-list-item d-flex justify-content-between align-items-center">
                                                                                        <span className="px-2" style={{ whiteSpace: "nowrap" }}>
                                                                                            <b>{attachment.fileType?.charAt(0)}</b> - {attachment.fileType} | Attachment {displayIndex}
                                                                                        </span>
                                                                                        <div className="d-flex align-items-center gap-2">
                                                                                            <div title="View Document" style={{ cursor: "pointer" }} onClick={() => onViewAttachment(attachment.filePath)} className="view-doc-btn-wrapper">
                                                                                                <FaEye color="green" size={18} />
                                                                                            </div>
                                                                                        </div>
                                                                                    </li>
                                                                                );
                                                                            })
                                                                        ) : (
                                                                            <li className="list-group-item text-muted">No attachments available</li>
                                                                        )}
                                                                    </ul>
                                                                );
                                                            })()
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    // Editable form — one or more attributes are pending
                                    fields.map((field, index) => {
                                        const { History_Attribute, History_Name, Is_Mandatory, Options = [] } = field;
                                        return (
                                            <div key={index}>
                                                <div className="mb-2">
                                                    <label className="form-label">
                                                        {History_Name} {Is_Mandatory && <span className="text-danger">*</span>}
                                                    </label>

                                                    {History_Attribute === "TextBox" && (
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={field.History_Value || ""}
                                                            maxLength={200}
                                                            disabled={field._isPrefilled}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                const regex = /^[`#*()_\\\-;':",./\w\s]*$/;
                                                                if (!regex.test(value)) return;
                                                                onFieldChange({ History_Value: value }, index);
                                                            }}
                                                        />
                                                    )}

                                                    {History_Attribute === "DateTime" && (
                                                        <input
                                                            type="datetime-local"
                                                            className="form-control"
                                                            value={field.selectedDateTime || ""}
                                                            disabled={field._isPrefilled}
                                                            onChange={(e) => {
                                                                const date = e.target.value;
                                                                let formatted = "";
                                                                if (date) {
                                                                    formatted = new Date(date)
                                                                        .toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: true })
                                                                        .replace(",", "")
                                                                        .replace(/\s?(am|pm)/i, (m) => m.toUpperCase());
                                                                }
                                                                onFieldChange({ selectedDateTime: date, History_Value: formatted }, index);
                                                            }}
                                                        />
                                                    )}

                                                    {History_Attribute === "DropDown" && (
                                                        <select
                                                            className="form-select"
                                                            value={field.selectedOption || ""}
                                                            disabled={field._isPrefilled}
                                                            onChange={(e) => {
                                                                const val = e.target.value;
                                                                onFieldChange({ selectedOption: val, History_Value: val }, index);
                                                            }}
                                                        >
                                                            <option value="">Select</option>
                                                            {field.Options?.map((opt, i) => (
                                                                <option key={i} value={opt}>{opt}</option>
                                                            ))}
                                                        </select>
                                                    )}

                                                    {History_Attribute === "Attachement" && (
                                                        <>
                                                            {!field._isPrefilled && (
                                                                <>
                                                                    <select
                                                                        className="form-select mb-2"
                                                                        value={field.urnFileType || ""}
                                                                        onChange={(e) => {
                                                                            onFieldChange({ urnFileType: e.target.value, selectedHistoryFile: null, History_Value: "" }, index);
                                                                            if (fileInputRefs.current[index]) {
                                                                                fileInputRefs.current[index].value = "";
                                                                            }
                                                                        }}
                                                                    >
                                                                        <option value="">Select Document Type</option>
                                                                        {Options.map((opt, i) => (
                                                                            <option key={i} value={opt}>{opt}</option>
                                                                        ))}
                                                                    </select>
                                                                    <div className="d-flex gap-2 align-items-center">
                                                                        <div className="position-relative flex-grow-1">
                                                                            <input
                                                                                ref={(el) => (fileInputRefs.current[index] = el)}
                                                                                type="file"
                                                                                accept=".jpg,.jpeg,.bitmap,.pdf,.doc,.docx,.tiff,.msg,.eml,.zip"
                                                                                className="form-control select-field-patient-history"
                                                                                onChange={(e) => {
                                                                                    const file = e.target.files?.[0];
                                                                                    onFieldChange({ selectedHistoryFile: file }, index);
                                                                                }}
                                                                                style={{ paddingRight: "10px" }}
                                                                            />
                                                                        </div>
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-sm custom-sumbitbtn"
                                                                            onClick={() => onAttachFile(index)}
                                                                            disabled={uploading || !field.urnFileType || !field.selectedHistoryFile}
                                                                            style={{ padding: '5px 8px' }}
                                                                        >
                                                                            {uploading ? (
                                                                                <div className="d-flex gap-2 align-items-center"><FaSpinner className="fa-spin" /> Uploading...</div>
                                                                            ) : "Upload"}
                                                                        </button>
                                                                    </div>
                                                                </>
                                                            )}

                                                            {field.HistoryAttachments?.length > 0 && (() => {
                                                                const typeCounters = {};
                                                                return (
                                                                    <ul className="list-group small mt-2">
                                                                        {field.HistoryAttachments.map((att, idx) => {
                                                                            if (!typeCounters[att.fileType]) { typeCounters[att.fileType] = 1; } else { typeCounters[att.fileType]++; }
                                                                            const displayIndex = typeCounters[att.fileType];
                                                                            return (
                                                                                <li key={idx} className="list-group-item uploaded-docs-list-item d-flex justify-content-between align-items-center">
                                                                                    <span className="px-2" style={{ whiteSpace: "nowrap" }}>
                                                                                        <b>{att.fileType?.charAt(0)}</b> - {att.fileType} | Attachment {displayIndex}
                                                                                    </span>
                                                                                    <div className="d-flex align-items-center">
                                                                                        <div title="View Document" style={{ cursor: "pointer" }} onClick={() => onViewAttachment(att.filePath)} className="view-doc-btn-wrapper">
                                                                                            <FaEye color="green" size={18} />
                                                                                        </div>
                                                                                        {!field._isPrefilled && att.isNew !== false && (
                                                                                            <div title="Delete Document" style={{ cursor: "pointer" }} onClick={() => onDeleteAttachment(index, idx)} className="delete-doc-btn-wrapper">
                                                                                                <i className="fas fa-trash-alt text-danger" style={{ fontSize: "15px" }}></i>
                                                                                            </div>
                                                                                        )}
                                                                                    </div>
                                                                                </li>
                                                                            );
                                                                        })}
                                                                    </ul>
                                                                );
                                                            })()}
                                                        </>
                                                    )}
                                                </div>
                                                {index < fields.length - 1 && <hr />}
                                            </div>
                                        );
                                    })
                                )
                            ) : (
                                <p className="text-center text-muted mb-0">No history data available for this test.</p>
                            )}
                        </div>

                        <div className="modal-footer p-2">
                            <button className="btn btn-danger" onClick={onClose}>
                                Close
                            </button>
                            {fields.length > 0 && vid && (
                                <button
                                    type="button"
                                    className="btn custom-sumbitbtn"
                                    onClick={onSave}
                                    disabled={saving}
                                >
                                    {saving ? <><FaSpinner className="fa-spin me-1" /> Saving...</> : "Save"}
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default TestHistoryModalComponent;
